import { formatDistanceToNow, differenceInMinutes, format } from 'date-fns';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/** Traffic-light color for a heartbeat age: green <2m, amber 2-10m, red >10m. */
function freshnessClass(date: Date): string {
  const minutes = differenceInMinutes(new Date(), date);

  if (minutes < 2) return 'text-status-active';
  if (minutes <= 10) return 'text-status-degraded';
  return 'text-status-failed';
}

export function LastSeen({
  timestamp,
  className,
}: {
  timestamp: string | null;
  className?: string;
}): JSX.Element {
  if (!timestamp) {
    return <span className={cn('font-mono text-xs text-muted-foreground', className)}>never</span>;
  }

  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return <span className={cn('font-mono text-xs text-muted-foreground', className)}>—</span>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('font-mono text-xs', freshnessClass(date), className)}>
          {formatDistanceToNow(date, { addSuffix: true })}
        </span>
      </TooltipTrigger>
      <TooltipContent>{format(date, 'yyyy-MM-dd HH:mm:ss')} (local)</TooltipContent>
    </Tooltip>
  );
}
